import { serviceMaker, methods, api } from "./index.js";

export const getCardData = () =>
  serviceMaker("/clients/dashboard", methods.GET, api.NGB);
export const getClientsData = () =>
  serviceMaker("/groups/template", methods.GET, api.NGB);
export const getClientCounts = () =>
  serviceMaker(
    "/runreports/ClientCounts?genericResultSet=false",
    methods.GET,
    api.NGB
  );
export const getClientTrends = (officeId, time) =>
  serviceMaker(
    `/runreports/ClientTrendsBy${time}?R_officeId=${officeId}&genericResultSet=false`,
    methods.GET,
    api.NGB
  );
export const getSTBCounts = () =>
  serviceMaker(
    `/runreports/STBCount?genericResultSet=false`,
    methods.GET,
    api.NGB
  );
export const getAmountCollected = () =>
  serviceMaker(
    `/runreports/Paymode Collection Chart?R_endDate=2019-12-31&R_officeId=-1&R_startDate=2019-12-01&genericResultSet=false`,
    methods.GET,
    api.NGB
  );
export const getStockItemDetails = (officeId) =>
  serviceMaker(
    `/runreports/Stock_Item_Details?R_officeId=${officeId}&genericResultSet=false`,
    methods.GET,
    api.NGB
  );
export const getverifyusername = (username) =>
  serviceMaker(`/users/verifyusername/${username}`, methods.GET, api.NGB);
export const getgeneratekey = (email) =>
  serviceMaker(`/users/generatekey/${email}`, methods.PUT, api.NGB);
export const getverifyemail = (email) =>
  serviceMaker(`/users/verifyemail/${email}`, methods.GET, api.NGB);
